export default "__VITE_ASSET__CT_zEK$4__"